/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { date, DateFormat, entity, enumeration } from '@gh/core-data';
import { HelpRequestDto, HelpRequestPriority, HelpRequestType } from './help.dto';

export const HelpBugMapper = entity<HelpRequestDto>({
  mode: enumeration(HelpRequestType),
  priority: enumeration(HelpRequestPriority),
  date: date(DateFormat.DateTime),
});
